import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import Modal from "./modal";

const Projects = () => {
  const { user } = useSelector((state) => state.auth) || {};
  const { email } = user || {};

  const {
    data: projects,
    isLoading,
    isError,
    error,
  } = useGetProjectsQuery(email);

  console.log("projects", projects);

  const itemsFromBackend = [
    {
      id: uuid(),
      teamId: 1,
      title: "Projects One",
      description: "This is Projects One",
      timestamp: 1661976143678,
    },
    {
      id: uuid(),
      teamId: 1,
      title: "Projects Two",
      description: "This is Projects Two",
      timestamp: 1661976143678,
    },
  ];

  const columnsFromBackend = {
    [uuid()]: {
      name: "Backlog",
      items: itemsFromBackend,
    },
    [uuid()]: {
      name: "Ready",
      items: [],
    },
    [uuid()]: {
      name: "Doing",
      items: [],
    },
    [uuid()]: {
      name: "Review",
      items: [],
    },
    [uuid()]: {
      name: "Blocked",
      items: [],
    },
  };

  const onDragEnd = (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }
  };
  const [columns, setColumns] = useState(columnsFromBackend);

  const [opened, setOpened] = useState(false);
  const controlModal = () => {
    setOpened((prevState) => !prevState);
  };

  //get current cards
  console.log(
    "columns",
    Object.entries(columns).map((item) => item[1])
  );

  return (
    <DragDropContext
      onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
    >
      <div className="flex flex-col w-auto h-auto overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
        <div>
          <div className="px-10 mt-6">
            <h1 className="text-2xl font-bold">Project Board</h1>
          </div>

          <div className="flex flex-row flex-grow px-10 mt-4 space-x-6">
            {Object.entries(columns).map(([columnId, column], index) => {
              return (
                <div
                  className="flex flex-col flex-shrink-0 w-72"
                  key={columnId}
                >
                  <div className="flex items-center flex-shrink-0 h-10 px-2">
                    <span className="block text-sm font-semibold">
                      {column.name}
                    </span>
                    <span className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                      6
                    </span>

                    {column.name === "Backlog" && (
                      <button
                        className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                        onClick={controlModal}
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          ></path>
                        </svg>
                      </button>
                    )}
                  </div>

                  <Droppable droppableId={columnId} key={columnId}>
                    {(provided, snapshot) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className="hover:bg-opacity-100"
                          style={{
                            padding: 4,
                            marginBottom: 10,
                            width: 250,
                            minHeight: 500,
                          }}
                        >
                          {column.items.map((item, index) => {
                            return (
                              <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className=" flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
                                      draggable="true"
                                    >
                                      <button className="absolute top-0 right-0 flex items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex">
                                        <svg
                                          className="w-4 h-4 fill-current"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                        </svg>
                                      </button>
                                      <span className="flex items-center h-6 px-3 text-xs font-semibold text-pink-500 bg-pink-100 rounded-full">
                                        {item?.title}
                                      </span>
                                      <h4 className="mt-3 text-sm font-medium">
                                        This is the title of the card for the
                                        thing that needs to be done.
                                      </h4>
                                      <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                                        <div className="flex items-center">
                                          <svg
                                            className="w-4 h-4 text-gray-300 fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                              clip-rule="evenodd"
                                            />
                                          </svg>
                                          <span className="ml-1 leading-none">
                                            Dec 12
                                          </span>
                                        </div>

                                        <img
                                          className="w-6 h-6 ml-auto rounded-full"
                                          src="https://randomuser.me/api/portraits/women/26.jpg"
                                          alt="img"
                                        />
                                      </div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                        </div>
                      );
                    }}
                  </Droppable>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* modal */}
      <Modal open={opened} control={controlModal} />
    </DragDropContext>
  );
};

export default Projects;
